
export const translations = {
  cs: {
    nav: {
      timeline: 'Přehled příprav',
      dashboard: 'Nástěnka',
      wedding: 'Svatba',
      wedding_team: 'Svatební tým',
      guests: 'Hosté',
      tasks: 'Úkoly',
      schedule: 'Harmonogram dne',
      entertainment: 'Zábava & Aktivity',
      budget: 'Rozpočet',
      vendors: 'Dodavatelé',
      rings: 'Prstýnky',
      ceremony: 'Obřad',
      seating: 'Sezení hostů',
      notes: 'Poznámky & dokumenty',
      templates: 'Komunikační šablony',
      settings: 'Nastavení'
    },
    common: {
      save: 'Uložit',
      cancel: 'Zrušit',
      delete: 'Smazat',
      edit: 'Upravit',
      add: 'Přidat',
      loading: 'Načítání...',
      search: 'Hledat...',
      days_to_go: 'dnů do svatby',
      passed: 'Svatba už proběhla',
      none: 'Žádné',
      confirm_delete: 'Opravdu chcete tuto položku smazat?',
      actions: 'Akce',
      upgrade: 'Upgrade',
      logout: 'Odhlásit se',
      note: 'Poznámka',
      linked: 'Propojeno'
    },
    guests: {
      title: 'Seznam hostů',
      add: 'Přidat hosta',
      edit: 'Upravit hosta',
      saved: 'Host uložen',
      save_error: 'Nepodařilo se uložit hosta',
      name: 'Jméno',
      status: 'Stav',
      kids: 'Děti',
      pending: 'Čeká',
      confirmed: 'Potvrzeno',
      declined: 'Odmítnuto',
      role: 'Role',
      roles: {
        guest: 'Běžný host',
        witness: 'Svědek',
        bridesmaid: 'Družička',
        best_man: 'Družba',
        parent: 'Rodič',
        wedding_coordinator: 'Svatební koordinátor'
      },
      stats: {
        total: 'Celkem lidí',
        adults: 'Dospělí',
        kids: 'Děti',
        bride_side: 'Strana nevěsty',
        groom_side: 'Strana ženicha',
        mutual: 'Společní',
        group_count_tooltip:
          'Počet osob v této skupině včetně doprovodu (+1) a dětí; odpovídá kapacitě. Počet řádků v seznamu může být nižší.'
      },
      form: {
        side: 'Strana',
        contact: 'Kontakt',
        plus_one: 'Doprovod (+1)',
        bride: 'Nevěsta',
        groom: 'Ženich',
        mutual: 'Společné',
        email: 'E-mail',
        phone: 'Telefon',
        allergies: 'Alergie / Dieta',
        notes: 'Poznámka'
      },
      relationships: {
        section_title: 'Vazby s ostatními hosty',
        section_hint:
          'Propojte tohoto hosta s dalšími z vašeho seznamu. Každý host má stále vlastní údaje a stav účasti.',
        save_guest_first: 'Nejprve uložte hosta, pak můžete přidávat vazby.',
        no_types_hint: 'V Nastavení → Obecné přidejte typy vazeb (např. pár, rodina), nebo počkejte na doplnění výchozích hodnot.',
        type_label: 'Typ vazby',
        other_guest: 'Druhý host',
        search_placeholder: 'Vyhledat jméno…',
        empty_search: 'Žádný host neodpovídá hledání',
        already_linked: 'už propojeno tímto typem',
        add_link: 'Přidat vazbu',
        remove: 'Odebrat vazbu',
        link_added: 'Vazba uložena',
        link_removed: 'Vazba odebrána',
        error_self: 'Hosta nelze propojit sám se sebou.',
        error_duplicate: 'Tato vazba už existuje.',
        list_badge: 'Vazby'
      }
    },
    tasks: {
      description: 'Popis',
      assign: 'Přiřadit',
      assigned_to: 'Přiřazeno komu',
      all_assignees: 'Všichni řešitelé',
      unassigned: 'Nepřiřazeno'
    },
    entertainment: {
      title: 'Zábava & Aktivity',
      subtitle: 'Naplánujte program, hry a hlasujte o nápadech hostů.',
      planned: 'Naplánováno',
      proposals: 'Návrhy hostů',
      add: 'Nová aktivita',
      form: {
        title: 'Název aktivity',
        desc: 'Popis / Poznámka',
        type: 'Typ',
        planned: 'Plánovaná aktivita',
        proposal: 'Návrh ke schválení',
        timing: 'Časování',
        all_day: 'Celodenní (Fotokoutek, Kniha hostů...)',
        timed: 'V konkrétní čas',
        from: 'Od',
        to: 'Do'
      },
      status: {
        approved: 'Schváleno',
        rejected: 'Zamítnuto',
        draft: 'Ke schválení'
      },
      stats: {
        total: 'Aktivity',
        votes: 'Hlasy',
        pending: 'Návrhy'
      }
    },
    timeline: {
      title: 'Průvodce přípravou',
      progress: 'Celkový pokrok',
      phases: {
        early: '12–9 měsíců předem',
        mid: '9–6 měsíců předem',
        approaching: '6–3 měsíce předem',
        final: '3–1 měsíc předem',
        last_week: 'Poslední týden',
        today: 'Svatební den',
        post_1_day: '1 den po svatbě',
        post_1_week: '1 týden po svatbě',
        post_1_month: '1 měsíc po svatbě'
      },
      status: {
        done: 'Hotovo',
        pending: 'Čeká',
        overdue: 'Zpoždění'
      }
    },
    budget: {
      planned: 'Plánováno',
      paid: 'Zaplaceno',
      remaining: 'Zbývá',
      subtitle: 'Spravujte své výdaje a platby.',
      empty_title: 'Žádné položky',
      empty_description: 'Začněte přidávat výdaje nebo propojte dodavatele.',
      table_item: 'Položka',
      table_category: 'Kategorie',
      table_plan: 'Plán',
      table_paid: 'Zaplaceno',
      table_actions: 'Akce',
      modal_edit: 'Upravit výdaj',
      modal_new: 'Nový výdaj',
      form_item_name: 'Název položky',
      form_category: 'Kategorie',
      form_planned_amount: 'Plánovaná částka',
      paid_czk: 'Zaplaceno (CZK)'
    },
    login: {
      subtitle: 'Přihlaste se do svého účtu',
      username_label: 'Uživatelské jméno',
      username_placeholder: 'Zadejte uživatelské jméno',
      password_placeholder: 'Zadejte heslo',
      submit: 'Přihlásit se',
      submitting: 'Přihlašování...',
      forgot_password: 'Zapomněli jste heslo?',
      reset_password: 'Obnovit heslo',
      error_username_required: 'Zadejte uživatelské jméno',
      error_password_required: 'Zadejte heslo',
      error_login_failed: 'Nepodařilo se přihlásit. Zkontrolujte uživatelské jméno a heslo.',
      reset_success: 'Pokud účet existuje a má e-mail, byl odeslán odkaz pro obnovu hesla.',
      reset_error: 'Chyba při obnově hesla',
      reset_send_error: 'Nepodařilo se odeslat žádost',
      password_label: 'Heslo',
      reset_send_button: 'Odeslat odkaz',
      reset_sending: 'Odesílání...',
      no_email: 'Nemáte e-mail?',
      contact_admin: 'Kontaktujte administrátora svatby pro reset hesla.'
    },
    settings: {
      wedding_info: 'Informace o svatbě',
      wedding_name_label: 'Název svatby',
      vendor_categories_label: 'Kategorie dodavatelů',
      vendor_types_description: 'Nadefinujte si typy služeb, které chcete na svatbě mít.',
      guest_relationship_types_title: 'Typy vazeb mezi hosty',
      guest_relationship_types_description:
        'Názvy vztahů (např. pár, manželé, rodina) se vybírají při propojování hostů v sekci Hosté.',
      guest_relationship_new_placeholder: 'Nový typ (např. Kamarádi)',
      guest_relationship_add: 'Přidat typ',
      guest_relationship_deleted: 'Typ odebrán',
      guest_relationship_delete_error: 'Typ nelze smazat – existují vazby tohoto typu. Nejdřív odeberte vazby u hostů.',
      guest_relationship_saved: 'Uloženo',
      date_label: 'Datum',
      location_label: 'Lokalita'
    },
    ai: {
      title: 'AI Asistent',
      placeholder: 'Zeptejte se na cokoliv ohledně svatby...',
      send: 'Odeslat',
      context_on: 'Kontext svatby zapnut',
      context_off: 'Kontext svatby vypnut',
      sensitive_on: 'Včetně citlivých dat',
      sensitive_off: 'Bez citlivých dat',
      provider_settings: 'Nastavení AI',
      clear_chat: 'Vymazat chat',
      empty_state: 'Jsem váš svatební AI asistent. Mohu vám pomoci s harmonogramem, texty emailů, rozpočtem nebo nápady na program.',
      typing: 'AI píše...',
      error_key: 'Chybí API klíč. Nastavte jej prosím v nastavení.',
      settings_title: 'AI Integrace (BYOK)',
      settings_desc: 'Vložte vlastní API klíče. Klíče se ukládají pouze v tomto prohlížeči.',
      key_placeholder: 'Vložte API klíč',
      test_connection: 'Test spojení',
      test_success: 'Spojení funguje!',
      test_fail: 'Chyba spojení',
      model: 'Model'
    },
    rings: {
        title: 'Snubní prsteny',
        subtitle: 'Vyberte si prsteny, které vás budou provázet celý život.',
        bride: 'Prsteny pro nevěstu',
        groom: 'Prsteny pro ženicha',
        style: 'Styl / Model',
        material: 'Materiál',
        size: 'Velikost',
        engraving: 'Rytina',
        vendor: 'Klenotnictví',
        price: 'Cena',
        status: 'Stav',
        status_potential: 'Ve výběru',
        status_confirmed: 'Potvrzeno',
        status_canceled: 'Zrušeno'
    },
    vendors: {
      attachments: 'Přílohy',
      attachment: 'Příloha',
      upload_file: 'Nahrát soubor',
      remove_file: 'Odebrat',
      download: 'Stáhnout',
      file_format_error: 'Povolené formáty: PDF, JPG, PNG, GIF, WEBP.',
      file_size_error: 'Soubor je příliš velký (max 5 MB).',
      max_files_error: 'Lze nahrát maximálně 3 soubory.',
      add_file: 'Přidat soubor'
    },
    wedding_team: {
      title: 'Svatební tým',
      subtitle: 'Nevěsta, ženich a koordinátor. Koordinátor je zároveň v seznamu hostů.',
      bride: 'Nevěsta',
      groom: 'Ženich',
      coordinator: 'Koordinátor',
      not_set: 'Nenastaveno',
      add_edit: 'Přidat / Upravit',
      name: 'Jméno',
      email: 'E-mail',
      phone: 'Telefon',
      allergies: 'Alergie / Dieta',
      notes: 'Poznámka'
    },
    ceremony: {
        title: 'Svatební obřad',
        subtitle: 'Detaily, role a harmonogram vašeho nejdůležitějšího okamžiku.',
        sections: {
            info: 'Základní info',
            contacts: 'Kontakty',
            roles: 'Role & osoby',
            steps: 'Časová osa',
            admin: 'Administrativa',
            music: 'Hudba',
            checklist: 'Checklist'
        },
        step_time: 'Čas konání',
        sync_to_schedule: 'Zobrazuje se v Harmonogramu dne (úprava jen zde)',
        meta: {
            type: 'Typ obřadu',
            location: 'Místo',
            plan_b: 'Mokrá varianta (Plán B)',
            civil: 'Civilní',
            civilni: 'Civilní',
            church: 'Církevní',
            cirkevni: 'Církevní',
            symbolic: 'Symbolický',
            symbolicky: 'Symbolický'
        },
        contact_role: 'Role (e.g. Officiant)',
        roles: {
            key: 'Klíčová role',
            person: 'Osoba',
            instructions: 'Instrukce'
        },
        step: {
            name: 'Název kroku',
            desc: 'Popis děje',
            cue: 'Signál (hudba/foto)',
            duration: 'Délka (min)'
        }
    }
  },
  en: {
    nav: {
      timeline: 'Preparation Guide',
      dashboard: 'Dashboard',
      wedding: 'Wedding',
      wedding_team: 'Wedding Team',
      guests: 'Guests',
      tasks: 'Tasks',
      schedule: 'Day Schedule',
      entertainment: 'Entertainment',
      budget: 'Budget',
      vendors: 'Vendors',
      rings: 'Rings',
      ceremony: 'Ceremony',
      seating: 'Guest Seating',
      notes: 'Notes & Docs',
      templates: 'Communication Templates',
      settings: 'Settings'
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      loading: 'Loading...',
      search: 'Search...',
      days_to_go: 'days to go',
      passed: 'Wedding has passed',
      none: 'None',
      confirm_delete: 'Are you sure you want to delete this item?',
      actions: 'Actions',
      upgrade: 'Upgrade',
      logout: 'Logout',
      note: 'Note',
      linked: 'Linked'
    },
    guests: {
      title: 'Guest List',
      add: 'Add Guest',
      edit: 'Edit Guest',
      saved: 'Guest saved',
      save_error: 'Failed to save guest',
      name: 'Name',
      status: 'Status',
      kids: 'Kids',
      pending: 'Pending',
      confirmed: 'Confirmed',
      declined: 'Declined',
      role: 'Role',
      roles: {
        guest: 'Guest',
        witness: 'Witness',
        bridesmaid: 'Bridesmaid',
        best_man: 'Best Man',
        parent: 'Parent',
        wedding_coordinator: 'Wedding Coordinator'
      },
      stats: {
        total: 'Total People',
        adults: 'Adults',
        kids: 'Children',
        bride_side: 'Bride Side',
        groom_side: 'Groom Side',
        mutual: 'Mutual',
        group_count_tooltip:
          'People in this group including plus-ones and children (capacity). The number of rows in the list may be lower.'
      },
      form: {
        side: 'Side',
        contact: 'Contact',
        plus_one: 'Plus One',
        bride: 'Bride',
        groom: 'Groom',
        mutual: 'Mutual',
        email: 'Email',
        phone: 'Phone',
        allergies: 'Allergies / Diet',
        notes: 'Note'
      },
      relationships: {
        section_title: 'Links to other guests',
        section_hint:
          'Connect this guest to others on your list. Each guest still has their own details and RSVP.',
        save_guest_first: 'Save the guest first, then you can add links.',
        no_types_hint: 'Under Settings → General add relationship types, or wait for default labels to be created.',
        type_label: 'Relationship type',
        other_guest: 'Other guest',
        search_placeholder: 'Search by name…',
        empty_search: 'No guest matches',
        already_linked: 'already linked with this type',
        add_link: 'Add link',
        remove: 'Remove link',
        link_added: 'Link saved',
        link_removed: 'Link removed',
        error_self: 'A guest cannot be linked to themselves.',
        error_duplicate: 'This link already exists.',
        list_badge: 'Links'
      }
    },
    tasks: {
      description: 'Description',
      assign: 'Assign',
      assigned_to: 'Assigned to',
      all_assignees: 'All Assignees',
      unassigned: 'Unassigned'
    },
    entertainment: {
      title: 'Entertainment & Activities',
      subtitle: 'Plan your program, games, and vote on guest ideas.',
      planned: 'Planned',
      proposals: 'Guest Proposals',
      add: 'New Activity',
      form: {
        title: 'Activity Title',
        desc: 'Description / Note',
        type: 'Type',
        planned: 'Planned Activity',
        proposal: 'Proposal',
        timing: 'Timing',
        all_day: 'All Day (Photobooth, Guestbook...)',
        timed: 'Specific Time',
        from: 'From',
        to: 'To'
      },
      status: {
        approved: 'Approved',
        rejected: 'Rejected',
        draft: 'Pending'
      },
      stats: {
        total: 'Activities',
        votes: 'Votes',
        pending: 'Pending'
      }
    },
    timeline: {
      title: 'Preparation Guide',
      progress: 'Overall Progress',
      phases: {
        early: '12–9 months before',
        mid: '9–6 months before',
        approaching: '6–3 months before',
        final: '3–1 month before',
        last_week: 'Last week',
        today: 'Wedding Day',
        post_1_day: '1 day after',
        post_1_week: '1 week after',
        post_1_month: '1 month after'
      },
      status: {
        done: 'Done',
        pending: 'Pending',
        overdue: 'Overdue'
      }
    },
    budget: {
      planned: 'Planned',
      paid: 'Paid',
      remaining: 'Remaining',
      subtitle: 'Manage your expenses and payments.',
      empty_title: 'No items',
      empty_description: 'Start adding expenses or link vendors.',
      table_item: 'Item',
      table_category: 'Category',
      table_plan: 'Plan',
      table_paid: 'Paid',
      table_actions: 'Actions',
      modal_edit: 'Edit expense',
      modal_new: 'New expense',
      form_item_name: 'Item name',
      form_category: 'Category',
      form_planned_amount: 'Planned amount',
      paid_czk: 'Paid (CZK)'
    },
    login: {
      subtitle: 'Sign in to your account',
      username_label: 'Username',
      username_placeholder: 'Enter username',
      password_placeholder: 'Enter password',
      submit: 'Sign in',
      submitting: 'Signing in...',
      forgot_password: 'Forgot password?',
      reset_password: 'Reset password',
      error_username_required: 'Please enter username',
      error_password_required: 'Please enter password',
      error_login_failed: 'Sign in failed. Check username and password.',
      reset_success: 'If the account exists and has an email, a reset link has been sent.',
      reset_error: 'Error resetting password',
      reset_send_error: 'Failed to send request',
      password_label: 'Password',
      reset_send_button: 'Send link',
      reset_sending: 'Sending...',
      no_email: 'No email?',
      contact_admin: 'Contact the wedding administrator to reset your password.'
    },
    settings: {
      wedding_info: 'Wedding Information',
      wedding_name_label: 'Wedding name',
      vendor_categories_label: 'Vendor categories',
      vendor_types_description: 'Define the types of services you want for your wedding.',
      guest_relationship_types_title: 'Guest relationship types',
      guest_relationship_types_description:
        'Labels (e.g. couple, spouses, family) are chosen when linking guests in the Guests section.',
      guest_relationship_new_placeholder: 'New type (e.g. Friends)',
      guest_relationship_add: 'Add type',
      guest_relationship_deleted: 'Type removed',
      guest_relationship_delete_error: 'Cannot delete – links of this type exist. Remove guest links first.',
      guest_relationship_saved: 'Saved',
      date_label: 'Date',
      location_label: 'Location'
    },
    ai: {
      title: 'AI Assistant',
      placeholder: 'Ask anything about your wedding...',
      send: 'Send',
      context_on: 'Wedding context ON',
      context_off: 'Wedding context OFF',
      sensitive_on: 'With sensitive data',
      sensitive_off: 'Safe mode (no PII)',
      provider_settings: 'AI Settings',
      clear_chat: 'Clear chat',
      empty_state: 'I am your wedding AI assistant. I can help with schedules, email drafts, budget planning, or creative ideas.',
      typing: 'AI is typing...',
      error_key: 'Missing API Key. Please configure it in Settings.',
      settings_title: 'AI Integration (BYOK)',
      settings_desc: 'Bring Your Own Key. Keys are stored only in this browser.',
      key_placeholder: 'Enter API Key',
      test_connection: 'Test Connection',
      test_success: 'Connection working!',
      test_fail: 'Connection failed',
      model: 'Model'
    },
    rings: {
        title: 'Wedding Rings',
        subtitle: 'Choose the rings that will accompany you all your life.',
        bride: 'Bride\'s Rings',
        groom: 'Groom\'s Rings',
        style: 'Style / Model',
        material: 'Material',
        size: 'Size',
        engraving: 'Engraving',
        vendor: 'Jeweler',
        price: 'Price',
        status: 'Status',
        status_potential: 'In selection',
        status_confirmed: 'Confirmed',
        status_canceled: 'Canceled'
    },
    vendors: {
      attachments: 'Attachments',
      attachment: 'Attachment',
      upload_file: 'Upload file',
      remove_file: 'Remove',
      download: 'Download',
      file_format_error: 'Allowed formats: PDF, JPG, PNG, GIF, WEBP.',
      file_size_error: 'File is too large (max 5 MB).',
      max_files_error: 'Maximum 3 files allowed.',
      add_file: 'Add file'
    },
    wedding_team: {
      title: 'Wedding Team',
      subtitle: 'Bride, groom, and coordinator. Coordinator also appears in the guest list.',
      bride: 'Bride',
      groom: 'Groom',
      coordinator: 'Coordinator',
      not_set: 'Not set',
      add_edit: 'Add / Edit',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      allergies: 'Allergies / Diet',
      notes: 'Note'
    },
    ceremony: {
        title: 'Ceremony',
        subtitle: 'Details, roles and schedule of your most important moment.',
        sections: {
            info: 'Basic Info',
            contacts: 'Contacts',
            roles: 'Roles & People',
            steps: 'Time line',
            admin: 'Admin',
            music: 'Music',
            checklist: 'Checklist'
        },
        step_time: 'Time',
        sync_to_schedule: 'Shown in Day Schedule (edit only here)',
        meta: {
            type: 'Ceremony Type',
            location: 'Location',
            plan_b: 'Plan B (Rain)',
            civil: 'Civil',
            civilni: 'Civil',
            church: 'Religious',
            cirkevni: 'Religious',
            symbolic: 'Symbolic',
            symbolicky: 'Symbolic'
        },
        contact_role: 'Role (e.g. Officiant)',
        roles: {
            key: 'Key Role',
            person: 'Person',
            instructions: 'Instructions'
        },
        step: {
            name: 'Step Name',
            desc: 'Description',
            cue: 'Cue (music/photo)',
            duration: 'Duration (min)'
        }
    }
  }
};

export function getTranslation(locale: string, key: string): string {
  const parts = key.split('.');
  let obj = (translations as any)[locale] || translations.cs;
  for (const part of parts) {
    if (!obj || !obj[part]) return key;
    obj = obj[part];
  }
  return obj;
}
